import moment from "moment";

const DateTimeLabel = ({ dateTime }) => {
  return <>{moment(dateTime).format("DD-MM-YYYY hh:mm:ss")}</>;
};

export default DateTimeLabel;
